<div class="header-container" [class.mwm-theme]="isMwmRoute">
  <mat-toolbar>
    <!-- Desktop View -->
    @if (!deviceSmall) {
    <mat-toolbar-row class="desktop-row">
      <!-- Logo Left -->
      <a [routerLink]="isMwmRoute ? '/math-with-meenu' : '/reception'" class="logo-container">
        @if (isMwmRoute) {
        <img src="assets/images/mwm-logo.png" alt="MWM" class="mwm-logo-img">
        <span class="mwm-header-text">Math With Meenu</span>
        } @else {
        <img src="assets/images/ksolve-logo.svg" alt="KSolve" class="logo-img">
        }
      </a>

      <!-- Navigation Right -->
      <div class="nav-links">
        @if (!isMwmRoute) {
        <!-- KSolve Nav -->
        <button mat-button routerLink="/reception" routerLinkActive="active-nav">Home</button>
        <button mat-button routerLink="/courses" routerLinkActive="active-nav">Courses</button>
        <a mat-button href="https://mathwithmeenu.com" class="nav-link-btn">Math With Meenu</a>
        <button mat-button routerLink="/contact-us" routerLinkActive="active-nav">Contact Us</button>
        <button mat-button routerLink="/privacy-policy" routerLinkActive="active-nav">Privacy Policy</button>

        @if (hasUserLoggedIn) {
        @if (!isKSolveAdmin) {
        <button mat-button routerLink="/my-account" routerLinkActive="active-nav">My Account</button>
        }
        @if (isKSolveAdmin) {
        <button mat-button routerLink="/admin/dashboard" routerLinkActive="active-nav">Admin Dashboard</button>
        }
        <button mat-button routerLink="/donate" routerLinkActive="active-nav">Donate</button>
        }
        } @else {
        <!-- MWM Nav -->
        <button mat-button routerLink="/math-with-meenu" routerLinkActive="active-nav"
          [routerLinkActiveOptions]="{exact: true}">Home</button>
        <button mat-button routerLink="/math-with-meenu/about" routerLinkActive="active-nav">About Us</button>


        <button mat-button routerLink="/math-with-meenu/register" routerLinkActive="active-nav"
          *ngIf="!hasMwmUserLoggedIn">Registration</button>

        <button mat-button routerLink="/math-with-meenu/admin/dashboard" routerLinkActive="active-nav"
          *ngIf="hasMwmUserLoggedIn && isAdmin">Admin Dashboard</button>

        <button mat-button routerLink="/math-with-meenu/profile" routerLinkActive="active-nav"
          *ngIf="hasMwmUserLoggedIn && !isAdmin">My Profile</button>

        }

        <button mat-flat-button class="login-btn" (click)="onLoginLogout()">
          {{loginButtonText}}
        </button>

        <a href="https://ksolve.com" class="ksolve-back-link" *ngIf="isMwmRoute">
          <span class="powered-by">Powered by</span>
          <img src="assets/images/ksolve-logo.svg" alt="Back to KSolve" class="ksolve-back-logo">
        </a>
      </div>
    </mat-toolbar-row>
    }

    <!-- Mobile View -->
    @if (deviceSmall) {
    <mat-toolbar-row class="mobile-row d-flex justify-content-between align-items-center">
      <a [routerLink]="isMwmRoute ? '/math-with-meenu' : '/reception'" class="logo-container">
        @if (isMwmRoute) {
        <span class="mwm-header-text">Math With Meenu</span>
        } @else {
        <img src="assets/images/ksolve-logo.svg" alt="KSolve" class="logo-img">
        }
      </a>

      <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Menu">
        <mat-icon>menu</mat-icon>
      </button>

      <mat-menu #menu="matMenu" class="modern-menu">
        @if (!isMwmRoute) {
        <button mat-menu-item routerLink="/reception">
          <mat-icon>home</mat-icon><span>Home</span>
        </button>
        <button mat-menu-item routerLink="/courses">
          <mat-icon>school</mat-icon><span>Courses & Books</span>
        </button>
        <a mat-menu-item href="https://mathwithmeenu.com">
          <mat-icon>functions</mat-icon><span>Math With Meenu</span>
        </a>
        <button mat-menu-item routerLink="/contact-us">
          <mat-icon>mail</mat-icon><span>Contact Us</span>
        </button>
        @if (hasUserLoggedIn && !isKSolveAdmin) {
        <button mat-menu-item routerLink="/my-account">
          <mat-icon>person</mat-icon><span>My Account</span>
        </button>
        }
        @if (isKSolveAdmin) {
        <button mat-menu-item routerLink="/admin/dashboard">
          <mat-icon>dashboard</mat-icon><span>Admin Dashboard</span>
        </button>
        }
        } @else {
        <button mat-menu-item routerLink="/math-with-meenu">
          <mat-icon>home</mat-icon><span>Home</span>
        </button>
        <button mat-menu-item routerLink="/math-with-meenu/about">
          <mat-icon>info</mat-icon><span>About Us</span>
        </button>
        <button mat-menu-item routerLink="/math-with-meenu/register" *ngIf="!hasMwmUserLoggedIn">
          <mat-icon>person_add</mat-icon><span>Registration</span>
        </button>
        <button mat-menu-item routerLink="/math-with-meenu/admin/dashboard" *ngIf="hasMwmUserLoggedIn && isAdmin">
          <mat-icon>dashboard</mat-icon><span>Admin Dashboard</span>
        </button>
        <button mat-menu-item routerLink="/math-with-meenu/profile" *ngIf="hasMwmUserLoggedIn && !isAdmin">
          <mat-icon>person</mat-icon><span>My Profile</span>
        </button>
        }

        <button mat-menu-item (click)="onLoginLogout()">
          <mat-icon>login</mat-icon><span>{{loginButtonText}}</span>
        </button>

        <a mat-menu-item href="https://ksolve.com" class="back-menu-item" *ngIf="isMwmRoute">
          <mat-icon>arrow_back</mat-icon>
          <div class="mobile-powered-container">
            <span class="mobile-powered-by">Powered by</span>
            <span>KSolve</span>
          </div>
        </a>
      </mat-menu>
    </mat-toolbar-row>
    }
  </mat-toolbar>
</div>